<script>
    export let questionset_id;
    export let question;
    export let user_language;
    export let responses;
    import question_translations_misc from "./questions/question_translations_misc.json";

    let { question_id, question_text, options } = question;
</script>

<section>
    <div class="question">{@html question_text[user_language]}</div>

    {#each Object.entries(options) as [idx, option]}
        <label for="{question_id}_{idx}">
            <input
                type="radio"
                name={question_id}
                id="{question_id}_{idx}"
                value="{parseFloat(option['value'])}"
                bind:group={responses[questionset_id][question_id]}
            />
            {option["option_text"][user_language]}</label
        >
    {/each}
    <label for="{question_id}_NA" class="na">
        <input
            type="radio"
            name={question_id}
            id="{question_id}_NA"
            value="{parseFloat('-1')}"
            class="na"
            bind:group={responses[questionset_id][question_id]}
        />
        {question_translations_misc["NA"][user_language]}
    </label>
</section>

<style lang="scss">
    section {
        margin: 2em auto;
    }

    .question {
        margin-bottom: 0.5em;
    }

    label {
        display: block;
        margin:.5em;

        &.na {
            color: var(--color-grey-med); 
            font-style: italic;
        }
    }

    input[type="radio"] {
        transform: scale(1.2);
        cursor: pointer;
        &.na {
            opacity: 0.5;
            filter: saturate(0);
        }
    }
</style>
